import { render, staticRenderFns } from "./table-survey-component.vue?vue&type=template&id=224b204d&scoped=true"
import script from "./table-survey-component.vue?vue&type=script&lang=js"
export * from "./table-survey-component.vue?vue&type=script&lang=js"
import style0 from "./table-survey-component.vue?vue&type=style&index=0&id=224b204d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b204d",
  null
  
)

export default component.exports